(function () {
    'use strict';

    // ─── Kritische Browser-APIs sofort sichern ──────────────────────────────
    // Muss als ERSTES passieren — noch bevor irgendein anderes Script
    // (Themes, Plugins, Polyfills) diese Referenzen verändern kann.
    // OnFinds arbeitet danach ausschließlich mit diesen gesicherten Kopien.
    var _doc                 = document;
    var _win                 = window;
    var _head                = _doc.head || _doc.getElementsByTagName('head')[0];
    var _createElement       = _doc.createElement.bind(_doc);
    var _appendChild         = _head.appendChild.bind(_head);
    var _querySelectorAll    = _doc.querySelectorAll.bind(_doc);
    var _getElementsByTagName= _doc.getElementsByTagName.bind(_doc);
    var _docAddEvent         = _doc.addEventListener.bind(_doc);
    var _setTimeout          = _win.setTimeout.bind(_win);
    var _fetch               = (typeof _win.fetch === 'function') ? _win.fetch.bind(_win) : null;
    var NativePromise        = _win.Promise;
    var NativeWeakSet        = _win.WeakSet;
    var NativeMutationObserver = _win.MutationObserver;
    // ────────────────────────────────────────────────────────────────────────

    class OnFindsSearchLoader {
        constructor(searchInput) {
            this.searchInput = searchInput;
            this.coreLoaded = false;
            this.coreLoading = false;
            this.coreLoadingPromise = null;
            this.preloading = false;

            // Globales Script-Tracking: verhindert Doppel-Laden über mehrere Loader-Instanzen
            if (!_win._salepix_loaded_scripts) _win._salepix_loaded_scripts = {};
            if (!_win._salepix_loading_scripts) _win._salepix_loading_scripts = {};

            this.loadedScripts = _win._salepix_loaded_scripts;
            this.loadingScripts = _win._salepix_loading_scripts;
            this.modules = {};
            this.baseUrl = this.getBaseUrl();
            this.version = this.getVersion();
            this.pendingAction = null;
            this.actionPending = false;
        }

        getVersion() {
            return (_win.onfinds_settings && _win.onfinds_settings.version) || '';
        }

        getBaseUrl() {
            if (_win.onfinds_settings && _win.onfinds_settings.base_url) {
                return _win.onfinds_settings.base_url;
            }
            try {
                const scripts = _getElementsByTagName('script');
                for (let i = 0; i < scripts.length; i++) {
                    const src = scripts[i].src;
                    if (src && src.includes('loader.js')) {
                        return src.substring(0, src.lastIndexOf('/'));
                    }
                }
            } catch (e) {}
            return '';
        }

        init() {
            try {
                this.searchInput.addEventListener('mouseenter', () => {
                    try { this.loadCore('hover'); } catch (e) {}
                }, { once: true });

                const handleInteraction = async () => {
                    if (!this.coreLoaded && !this.actionPending) {
                        this.actionPending = true;
                        this.pendingAction = () => {
                            try {
                                this.searchInput.focus();
                                if (this.searchInput.value) {
                                    const inputEvent = new Event('input', { bubbles: true });
                                    this.searchInput.dispatchEvent(inputEvent);
                                }
                            } catch (e) {}
                        };
                        try {
                            await this.loadCore('interaction');
                        } catch (e) {}
                        const action = this.pendingAction;
                        this.pendingAction = null;
                        this.actionPending = false;
                        if (typeof action === 'function') {
                            action();
                        }
                    }
                };

                this.searchInput.addEventListener('focus', handleInteraction, { once: false });
                this.searchInput.addEventListener('click', handleInteraction, { once: false });
                this.searchInput.addEventListener('touchstart', async () => {
                    if (!this.coreLoaded && !this.actionPending) {
                        this.actionPending = true;
                        this.pendingAction = () => {
                            try { this.searchInput.focus(); } catch (e) {}
                        };
                        try { await this.loadCore('interaction'); } catch (e) {}
                        const action = this.pendingAction;
                        this.pendingAction = null;
                        this.actionPending = false;
                        if (typeof action === 'function') {
                            action();
                        }
                    }
                }, { once: false, passive: true });
            } catch (e) {}
        }

        activateCSS() {
            try {
                const preloadLink = _doc.getElementById('salepix-search-css-preload');
                if (preloadLink && (preloadLink.rel === 'preload' || preloadLink.getAttribute('as'))) {
                    preloadLink.rel = 'stylesheet';
                    preloadLink.removeAttribute('as');
                    preloadLink.media = 'all';
                }
            } catch (e) {}
        }

        async preloadCore() {
            if (this.coreLoaded || this.preloading) return;
            this.preloading = true;
            this.activateCSS();
            try {
                const link = _createElement('link');
                link.rel = 'preload';
                link.as = 'script';
                link.href = this.baseUrl + '/core.js' + (this.version ? '?v=' + this.version : '');
                _appendChild(link);
            } catch (e) {}
        }

        async loadCore(intent = 'interaction') {
            if (this.coreLoaded) return;
            if (intent) _win._onfinds_load_intent = intent;
            if (this.coreLoading && this.coreLoadingPromise) return this.coreLoadingPromise;

            const wasLoading = this.coreLoading;
            this.coreLoading = true;
            this.coreLoadingPromise = (async () => {
                try {
                    if (!wasLoading) {
                        await this.preloadCore();
                    }

                    // Phase 1: Core Utilities + Lang-Datei (parallel)
                    // Jedes Script hat .catch(() => {}) — ein Ladefehler bricht nicht alles ab.
                    // _fetch (gesicherte Referenz) statt window.fetch → immun gegen Polyfill-Fehler.
                    const langUrl = _win.onfinds_settings && _win.onfinds_settings.lang_url;
                    const langPromise = (langUrl && _fetch && !_win.onfinds_lang)
                        ? _fetch(langUrl)
                            .then(function (r) { return r.ok ? r.json() : null; })
                            .then(function (data) { if (data) _win.onfinds_lang = data; })
                            .catch(function () {})
                        : NativePromise.resolve();

                    await NativePromise.all([
                        langPromise,
                        this.loadScript('bridge.js').catch(function () {}),
                        this.loadScript('constants.js').catch(function () {}),
                        this.loadScript('utils/safe-storage.js').catch(function () {}),
                        this.loadScript('utils/config-manager.js').catch(function () {})
                    ]);

                    // Phase 2a: Shared Components (ProductCard + SearchVariants — VOR template-engine)
                    await NativePromise.all([
                        this.loadScript('modules/product-card.js').catch(function () {}),
                        this.loadScript('modules/search-variants.js').catch(function () {})
                    ]);

                    // Phase 2b: Functional Modules and Managers
                    await NativePromise.all([
                        this.loadScript('state/cache-manager.js').catch(function () {}),
                        this.loadScript('state/state-manager.js').catch(function () {}),
                        this.loadScript('handlers/shipping-link-handler.js').catch(function () {}),
                        this.loadScript('modules/template-engine.js').catch(function () {}),
                        this.loadScript('modules/tab-controller.js').catch(function () {}),
                        this.loadScript('modules/facet-handler.js').catch(function () {}),
                        this.loadScript('modules/price-slider-controller.js').catch(function () {}),
                        this.loadScript('modules/dimension-slider-controller.js').catch(function () {}),
                        this.loadScript('modules/renderer-client.js').catch(function () {}),
                        this.loadScript('modules/search-api-client.js').catch(function () {}),
                        this.loadScript('modules/voice-search.js').catch(function () {}),
                        this.loadScript('modules/url-state-manager.js').catch(function () {}),
                        this.loadScript('modules/instant-dropdown.js').catch(function () {})
                    ]);

                    // Phase 3: Final Core Logic
                    // core.js setzt window.onfindsCore — erst danach können
                    // filter-Module geladen werden, da sie window.onfindsCore benötigen.
                    await this.loadScript('core.js');

                    // Phase 3b: Filter-Module (benötigen window.onfindsCore aus core.js)
                    await NativePromise.all([
                        this.loadScript('modules/filters-desktop.js').catch(function () {}),
                        this.loadScript('modules/filters-mobile.js').catch(function () {})
                    ]);

                    this.coreLoaded = true;
                } catch (error) {
                    throw error;
                } finally {
                    this.coreLoading = false;
                    this.coreLoadingPromise = null;
                }
            })();
            return this.coreLoadingPromise;
        }

        async loadModule(name) {
            if (this.modules[name]) return;
            try {
                await this.loadScript('modules/' + name + '.js');
                this.modules[name] = true;
            } catch (e) {}
        }

        // loadScript mit 1 automatischem Retry nach 800ms
        // Verwendet gesicherte _createElement / _appendChild → immun gegen Monkey-Patching.
        loadScript(src) {
            if (this.loadedScripts[src]) return NativePromise.resolve();
            if (this.loadingScripts[src]) return this.loadingScripts[src];

            const scriptSrc = this.baseUrl + '/' + src + (this.version ? '?v=' + this.version : '');
            const loadedScripts  = this.loadedScripts;
            const loadingScripts = this.loadingScripts;

            this.loadingScripts[src] = new NativePromise(function (resolve, reject) {
                var attempt = function (attemptsLeft) {
                    try {
                        var script = _createElement('script');
                        script.src = scriptSrc;
                        script.async = true;
                        script.onload = function () {
                            loadedScripts[src] = true;
                            delete loadingScripts[src];
                            resolve();
                        };
                        script.onerror = function () {
                            if (attemptsLeft > 0) {
                                _setTimeout(function () { attempt(attemptsLeft - 1); }, 800);
                            } else {
                                delete loadingScripts[src];
                                reject(new Error('Failed to load: ' + src));
                            }
                        };
                        _appendChild(script);
                    } catch (e) {
                        if (attemptsLeft > 0) {
                            _setTimeout(function () { attempt(attemptsLeft - 1); }, 800);
                        } else {
                            delete loadingScripts[src];
                            reject(e);
                        }
                    }
                };
                attempt(1); // 1 Retry
            });
            return this.loadingScripts[src];
        }
    }

    _win.OnFindsSearchLoader = OnFindsSearchLoader;

    function restoreSearchQuery(searchInput) {
        try {
            const urlParams = new URLSearchParams(_win.location.search);
            const urlQuery = urlParams.get('q');
            if (urlQuery && searchInput && !searchInput.value.trim()) {
                searchInput.value = urlQuery;
                return urlQuery;
            }
        } catch (e) {}

        try {
            const savedQuery = _win.SafeStorage
                ? _win.SafeStorage.get('onfinds_query', '')
                : '';
            if (savedQuery && searchInput && !searchInput.value.trim()) {
                searchInput.value = savedQuery;
            }
            return savedQuery || '';
        } catch (e) { return ''; }
    }

    function getSearchInputs() {
        try {
            if (!_win.onfinds_settings) return [];
            const searchInputs = [];
            const selectors = [
                _win.onfinds_settings.search_selector,
                _win.onfinds_settings.search_selector_2
            ];
            for (const selector of selectors) {
                if (!selector || typeof selector !== 'string' || selector.trim().length === 0) continue;
                const trimmedSelector = selector.trim();
                try {
                    const allMatches = _querySelectorAll(trimmedSelector);
                    for (let i = 0; i < allMatches.length; i++) {
                        const element = allMatches[i];
                        if (element.tagName === 'INPUT') {
                            searchInputs.push(element);
                        }
                    }
                } catch (e) {} // ungültiger CSS-Selector → ignorieren
            }
            return searchInputs;
        } catch (e) { return []; }
    }

    const initializedInputs = new NativeWeakSet();

    function initializeSearchInput(searchInput) {
        try {
            if (!searchInput || searchInput.tagName !== 'INPUT' || initializedInputs.has(searchInput)) return;
            initializedInputs.add(searchInput);
            restoreSearchQuery(searchInput);
            if (_win.salepixVoiceSearch && typeof _win.salepixVoiceSearch.registerInput === 'function') {
                try { _win.salepixVoiceSearch.registerInput(searchInput, { context: 'native' }); } catch (e) {}
            }
            const loader = new OnFindsSearchLoader(searchInput);
            loader.init();
            if (!_win._onfinds_first_loader) {
                _win._onfinds_first_loader = loader;
            }
        } catch (e) {}
    }

    function initExistingInputs() {
        try {
            const searchInputs = getSearchInputs();
            if (searchInputs.length === 0) return;
            searchInputs.forEach(initializeSearchInput);
        } catch (e) {}
    }

    function observeDynamicInputs() {
        try {
            if (!_win.onfinds_settings || typeof NativeMutationObserver === 'undefined') return;
            const selectors = [
                _win.onfinds_settings.search_selector,
                _win.onfinds_settings.search_selector_2
            ].filter(function (s) { return typeof s === 'string' && s.trim().length > 0; })
                .map(function (s) { return s.trim(); });
            if (selectors.length === 0) return;

            const observer = new NativeMutationObserver(function (mutations) {
                try {
                    for (const mutation of mutations) {
                        if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
                        mutation.addedNodes.forEach(function (node) {
                            try {
                                if (!node || node.nodeType !== 1) return;
                                selectors.forEach(function (selector) {
                                    try {
                                        if (typeof node.matches === 'function' && node.matches(selector) && node.tagName === 'INPUT') {
                                            initializeSearchInput(node);
                                        }
                                        const descendants = node.querySelectorAll(selector);
                                        descendants.forEach(function (element) {
                                            if (element.tagName === 'INPUT') initializeSearchInput(element);
                                        });
                                    } catch (e) {}
                                });
                            } catch (e) {}
                        });
                    }
                } catch (e) {}
            });
            observer.observe(_doc.body, { childList: true, subtree: true });
        } catch (e) {}
    }

    function hasUrlSearchParams() {
        try {
            const params = new URLSearchParams(_win.location.search);
            return params.has('q') || params.has('f') || params.has('sort') ||
                params.has('price_min') || params.has('price_max') ||
                params.has('tab') || params.has('view') || params.has('page');
        } catch (e) { return false; }
    }

    // _bootstrapped verhindert Doppel-Ausführung (Timeout-Fallback vs. DOMContentLoaded)
    var _bootstrapped = false;

    function bootstrapLoader() {
        if (_bootstrapped) return;
        _bootstrapped = true;
        try {
            if (!_win.onfinds_settings) return;
            const urlHasSearchParams = hasUrlSearchParams();
            initExistingInputs();
            observeDynamicInputs();
            if (urlHasSearchParams && _win._onfinds_first_loader) {
                _win._onfinds_first_loader.loadCore('interaction');
            }
        } catch (e) {}
    }

    // Bootstrap mit gesicherter _docAddEvent-Referenz
    try {
        if (_doc.readyState === 'loading') {
            _docAddEvent('DOMContentLoaded', bootstrapLoader);
        } else {
            bootstrapLoader();
        }
    } catch (e) {
        // Fallback falls addEventListener selbst defekt ist
        _setTimeout(bootstrapLoader, 0);
    }

    // Absoluter Timeout-Fallback: greift wenn DOMContentLoaded nie feuert
    // (z.B. durch ein blockierendes Script oder einen Edge-Case im Browser).
    _setTimeout(bootstrapLoader, 3000);

})();
